import { useEffect, useState } from 'react';
import useUserAccount from '../../../hooks/userAccountHook';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { getSelectedCountry } from '../../../states/slices/resourceSlice';
import { useSelector } from 'react-redux';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { XCircleIcon } from 'lucide-react';
type QuoteIframProps = {
  onProceed: () => void;
  onClose: () => void;
  isRenewPolicy?: boolean;
  policyNumber?: string;
  signup?: any;
  isPremiumFinancing?: boolean;
};

const QuoteIframe = ({ onClose, isRenewPolicy = false, policyNumber, signup, isPremiumFinancing = false }: QuoteIframProps) => {
  const { getInsurer, user } = useUserAccount();
  const [loading, setLoading] = useState(true);
  const insurer = getInsurer();
  const country = useSelector(getSelectedCountry)
  // Helper function to safely stringify objects with circular references and handle non-serializable values
  const safeStringify = (obj: any): string => {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      // Handle circular references
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) return '[Circular]';
        seen.add(value);

        // Handle DOM elements and other non-serializable objects
        if (value instanceof HTMLElement) return '[HTMLElement]';
        if (value instanceof Window) return '[Window]';
        if (value instanceof Node) return '[Node]';

        // Handle functions
        if (typeof value === 'function') return '[Function]';
      }

      // Return value as is if it's a primitive or safe to serialize
      return value;
    });
  };

  const signupParam = signup ? encodeURIComponent(safeStringify(signup)) : '';
  // Create a new user object without role and account properties
  const userWithoutSensitiveData = user ? (({ role, account, ...rest }) => rest)(user) : null;
  const adminParam = userWithoutSensitiveData ? encodeURIComponent(safeStringify(userWithoutSensitiveData)) : '';
  const [widgetUrl, setWidgetUrl] = useState<string>(getWidgetUrl);


  useEffect(() => {
    setWidgetUrl(getWidgetUrl());
  }, [insurer, isRenewPolicy, policyNumber, signupParam]);

  const handleLoad = () => {
    setLoading(false);
  };

  function getWidgetUrl(): string {
    return `${process.env.REACT_APP_CLIENT_WEBSITE}/widgets/admin?insurer=${insurer?.id}${country ? `&country=${country?.id}` : ''}${adminParam ? `&admin=${adminParam}` : ''}${isPremiumFinancing ? `&premiumFinancing=${isPremiumFinancing}` : ''}${isRenewPolicy ? `&renewPolicy=${isRenewPolicy}` : ''}${policyNumber ? `&policyNumber=${policyNumber}` : ''}${signup ? `&signup=${signupParam}` : ''}`;
    // return  `${process.env.REACT_APP_CLIENT_WEBSITE}/widgets/admin?insurer=${insurer?.id}${isRenewPolicy ? `&renewPolicy=${isRenewPolicy}` : ''}${policyNumber ? `&policyNumber=${policyNumber}` : ''}${signup ? `&signup=${signupParam}` : ''}${country ? `&country=${country?.id}` : ''}${adminParam ? `&admin=${adminParam}` : ''}${isPremiumFinancing ? `&premiumFinancing=${isPremiumFinancing}` : ''}`;
  }

  return (
    <div className="bg-white ">
      {loading && (
        <div
          className="h-screen flex items-center"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}>
          Loading...
        </div>
      )}

      {/* {showWidget && ( */}
      <div className="bg-white ">
        <div className='py-4'></div>
        <iframe
          onLoad={handleLoad}
          src={widgetUrl}
          title="Brolly Insurance... "
          width="100%"
          height="700"></iframe>
      </div>

      {/* )} */}
    </div>
  );
};
export default QuoteIframe;
